import { TrackSession } from "../models/TrackSession";
import { Subscription, Subject } from "rxjs";
import { timer } from "rxjs";
import { GpsTracker } from "./gps-tracker";
import { EventDetailsModel, EventProvider } from "../providers/event/event";
import { AutoPause } from "./autopause/autopause";
import { Platform, ToastController } from "@ionic/angular";
import { Injectable, NgZone } from "@angular/core";
import { LocationHandlerUtil } from "./location-handler-utils";
import { GoogleMapsCreator, LeafletCreator, MapHandlerCreator } from "./map-factory/map-factory";
import { AppInjector } from '../app/app.module';
import { DistanceUnit, TrackingService } from "../providers/tracking.service";
import { environment } from "src/environments/environment";

declare var BackgroundGeolocation, Location;
export class LocationProvider {
    DISTANCE_TO_WIN: number = Infinity; //in meters
    KM_PACE: number = 1000; // in meters
    trackingService = AppInjector.get(TrackingService);
    eventService = AppInjector.get(EventProvider);

    TOTAL_KM: number = 999999;
    checkPoints = Array(this.TOTAL_KM).fill(false); // to play the sound each km

    startTime: Date;

    paused: boolean = true;

    noGPScounter: number = 0;

    authStatus: number = 0;

    config = {
        mapHandler: null,
        currentDuration: 0,
        isCalculate: false,
        controllerScope: null,
        prev: null,
        session: null,
        locaterConfig: null,
        splited: [],
        isError: false,
        errorCnt: 0,
        lastStep: 0,
        lastPos: 0,
        betterPos: null,
        started: false,
        hasDistance: false
    };

    event: EventDetailsModel;

    stopWatch: Subscription;
    platform: Platform;
    map: any;

    trackSession = new TrackSession();
    check: boolean = false;
    started: boolean = false;
    reachedSub = null;
    first_position: boolean = false;
    init_position: any = null;
    competitors = [];

    //route logic
    placementEnabled: boolean = false;
    hasRoute: boolean = false;
    startingPoint: any = null;
    finishPoint: any = null;
    atFinishPoint: boolean = false;
    reachedStartingPointSub = null;

    //bad counter for acc < 65
    counter: number = 0;
    bad_counter: number = 0;
    first_start: boolean = false;
    mustCalculate: boolean = false;
    raceFinished: boolean = false;
    zone: NgZone;
    toastCtrl: ToastController;
    storageService;

    // Background Geolocation State
    deviceInfo: any;
    state: any;
    enabled: boolean;
    isMoving: boolean;
    distanceFilter: number;
    stopTimeout: number;
    autoSync: boolean;
    stopOnTerminate: boolean;
    startOnBoot: boolean;
    debug: boolean;
    provider: any;
    odometer: any;
    motionActivity: any;
    disableStopDetection: any;
    disableElasticity: any;
    onLocationSub: any = null;

    // AUTO STOP FEATURE 
    lastCoordinates: any = null;
    autoStartTrigger: boolean = false;

    // realtime Platzierung
    placement: boolean = false;

    //providers
    appDetector: any;

    city: string = "";
    country_code: string = "";

    constructor(map, reachedSub, event, zone, toastCtrl, platform, reachedStartingPointSub, storageService, appDetector, offline, parentInstance = null, onLocationSub = null) {
        this.initConfig(map, reachedSub, event, zone, toastCtrl, platform, reachedStartingPointSub, storageService, appDetector, offline);

        this.platform.ready().then(this.onDeviceReady.bind(this))

        this.getAllCompetitors();

        this.state = {};
        // BackgroundGeolocation initial config.
        this.isMoving = false;
        this.enabled = false;
        this.autoSync = false;
        this.distanceFilter = 5;
        this.stopTimeout = 1;
        this.stopOnTerminate = true;
        this.startOnBoot = true;
        this.debug = false;

        if (onLocationSub) { this.onLocationSub = onLocationSub; }
        // UI members
        this.motionActivity = 'Activity';
    }

    getAllCompetitors() {
        if (this.event)
            this.storageService.getSaved("participants-" + this.event.id).then((c) => {
                this.competitors = Object.assign([], c);
            });
    }

    onDeviceReady() {
        BackgroundGeolocation.getDeviceInfo().then((deviceInfo) => {
            this.deviceInfo = deviceInfo;
        }).catch(err => "getDeviceInfo err" + err);

        // We prompt you for a unique identifier in order to post locations tracker.transistorsoft.com

        // TEST SWITCH OFF
        this.configureBackgroundGeolocation();
    }

    onFirstPositionFind() {
        BackgroundGeolocation.getCurrentPosition({
        }, (location: Location) => {
            this.init_position = location;
            this.getMapHandler().positionMarker(location);
        });
    }

    initConfig(map, reachedSub, event, zone, toastCtrl, platform, reachedStartingPointSub, storageService, appDetector, google) {
        this.config.mapHandler = (google) ? new GoogleMapsCreator(map) : new LeafletCreator(map);
        this.map = map;
        this.platform = platform;
        this.event = event;
        this.zone = zone;
        this.config.lastStep = 0;
        this.reachedSub = reachedSub;
        this.reachedStartingPointSub = reachedStartingPointSub;
        this.toastCtrl = toastCtrl;
        this.storageService = storageService;
        this.appDetector = appDetector;
    }

    startTrack(startTime: number = 0) {
        if (!this.first_start) {
            this.config.lastPos = 0;
            this.config.lastStep = 0;
            this.config.currentDuration = startTime;
            this.config.splited = [];
            this.run();
            if (!this.hasRoute) this.getMapHandler().newPoly();
            this.first_start = true;
            this.startTime = (startTime > 0) ? new Date(new Date().getTime() - (this.getCurrentDuration() * 1000)) : new Date();
        } else {
            this.check = true;
            this.startTime = new Date(new Date().getTime() - (this.getCurrentDuration() * 1000));
        }

        this.setDistanceToWin();
        this.mustCalculate = true;
        this.setIsCalculate(true);
        this.clock();
        this.startTracking();
    }

    setDistanceToWin() {
        if (this.event) {
            if (this.event.streckeconv && !this.event.streckeconv.toLocaleLowerCase().includes('var')) {
                this.config.hasDistance = true;
                this.DISTANCE_TO_WIN = Number(this.event.streckeconv.replace(',', '.').replace(/[a-zA-Z ]/g, "")) * 1000;
            } else {
                this.config.hasDistance = false;
            }
        }
    }

    public startTracking() {
        if (!this.started) {
            this.check = true;
            this.raceFinished = false;
            this.odometer = GpsTracker.sumDistance;
            BackgroundGeolocation.resetOdometer(() => console.log('- BG reset success'));

            if (this.platform.is('android')) {
                BackgroundGeolocation.changePace(true, () => {
                }, (err) => {
                    console.log('ERROR: ' + err);
                });
            }

            this.paused = false;
        }
    }

    clear() {
        this.config.lastPos = 0;
        this.config.lastStep = 0;
        this.config.currentDuration = 0;
        this.odometer = 0;
        this.config.splited = [];
        this.trackerTime = 0;
        this.localDistance = 0;
        this.locationCounts = 0;

        if (!this.hasRoute) {
            this.getMapHandler().newPoly();
            this.getMapHandler().deleteMarkers();
            this.getMapHandler().removeAllPath();
        }
        GpsTracker.sumDistance = 0;
        GpsTracker.avgSpeed = 0;
        GpsTracker.currentSpeed = "0";
        GpsTracker.maxSpeed = 0;
        GpsTracker.lastAltitude = 0;
        GpsTracker.altitudeGainPerKm = 0;
        GpsTracker.altitudeLossPerKm = 0;

        this.raceFinished = false;
        this.first_start = false;
        this.paused = true;

        this.checkPoints = Array(this.TOTAL_KM).fill(false); // to play the sound each km

        if (this.config.started) {
            try {
                BackgroundGeolocation.resetOdometer(() => console.log('- BG reset success'));
            } catch (err) {
                console.log('error while BackgroundGeolocation.resetOdometer(): ' + err);
            }

            this.config.started = false;
        }
    }

    stopTrack() {
        this.terminate();
        // this.setIsCalculate(false);
        this.setPrev(null);
        this.mustCalculate = false;
        this.paused = true;
        this.odometer = GpsTracker.sumDistance;
        this.onLocationSub = null;
    }

    terminate(flag?) {
        if (this.getStarted()) {
            if (this.stopWatch) {
                this.stopWatch.unsubscribe();
                // this.stopWatch = null;
            }
            this.config.started = false;
            this.check = false;
        }
    }

    pluginTerminate() {
        BackgroundGeolocation.stop(() => console.log('- BG stop success'));
    }

    run() {
        this.paused = false;
        if (!this.config.started) {
            this.config.started = true;
        }
    }

    /*
        the tracker time indicates the working period in seconds
    */
    trackerTime: number = 0;
    clock() {
        this.stopWatch = timer(0, 1000).subscribe(() => {
            this.trackerTime++;
            this.setCurrentTime();
            GpsTracker.currentSpeed = this.calcSpeed();
            this.checkForWin();
        });
    }

    geoSuccess(location: Location) {
        try {
            setTimeout(() => {
                this.getMapHandler().positionMarker(location);
                // this.getMapHandler().flyTo({ latitude: location.coords.latitude, longitude: location.coords.longitude });
                // if (this.placementEnabled)

                if (this.appDetector.isEventsApp() || this.appDetector.isForestApp() || this.appDetector.isHannoverApp()) {
                    if (this.placement) {
                        this.getMapHandler().positionNearestCompetitors(this.getNearestCompetitors(location));
                    }
                }
            });

            if (this.onLocationSub) {
                this.onLocationSub.next(location);
            }

            if (!this.raceFinished && this.hasRoute) {

                // check if the finish point has been reached
                //this.atFinishPoint = LocationHandlerUtil.defDistance(currentPosition, { lat: this.finishPoint.lat(), lng: this.finishPoint.lng() }, 20);
            }

            if (this.locationCounts > 7 && !this.hasRoute) {
                // if (this.pointsBuffer.push(location.coords) == 3) {
                //     let step = 0.05;
                //     for (let t = 0; t <= 1; t += step) {
                //         let x = Math.pow(1 - t, 2) * this.pointsBuffer[0].latitude + 2 * (1 - t) * t * this.pointsBuffer[1].latitude + Math.pow(t, 2) * this.pointsBuffer[2].latitude;
                //         let y = Math.pow(1 - t, 2) * this.pointsBuffer[0].longitude + 2 * (1 - t) * t * this.pointsBuffer[1].longitude + Math.pow(t, 2) * this.pointsBuffer[2].longitude;
                //         if (!this.raceFinished) {
                //             this.getMapHandler().addPolyDestination({ latitude: x, longitude: y });
                //             this.getMapHandler().drawPolyLines(true);
                //         }
                //         this.getMapHandler().positionMarker(location);
                //         this.getMapHandler().setMapCenter(location);
                //         // this.getMapHandler().flyTo({ latitude: x, longitude: y });
                //     }
                //     this.pointsBuffer = [];
                //     if (this.city.length == 0) {
                //         this.searchForCity(location.coords.latitude, location.coords.longitude);
                //     }
                // }
            } else if (this.locationCounts > 3 && this.locationCounts <= 7 && !this.hasRoute) {
                if (!this.raceFinished) {
                    // this.getMapHandler().addPolyDestination({ latitude: location.coords.latitude, longitude: location.coords.longitude });
                    // this.getMapHandler().drawPolyLines(true);
                }
                this.getMapHandler().positionMarker(location);
                this.getMapHandler().setMapCenter(location);
                // this.getMapHandler().flyTo({ latitude: location.coords.latitude, longitude: location.coords.longitude });
            }

            if (this.mustCalculate) {
                GpsTracker.currentSpeed = this.calcSpeed();
                // this.toast("c: " + location.coords.altitude + "||l:" + GpsTracker.lastAltitude + "||g:" + GpsTracker.altitudeGainPerKm + "||a:" + location.coords.altitude_accuracy);
                // this.eventService.getElevation(location.coords.latitude, location.coords.longitude).then((res) => {
                //     if (!res) return;

                //     let altitude = res.results[0].elevation;

                //     if (altitude > GpsTracker.lastAltitude && GpsTracker.lastAltitude != 0) {
                //         let gain = altitude - GpsTracker.lastAltitude;
                //         GpsTracker.altitudeGainPerKm += gain;
                //     } else if (altitude < GpsTracker.lastAltitude && GpsTracker.lastAltitude != 0) {
                //         let loss = GpsTracker.lastAltitude - altitude;
                //         GpsTracker.altitudeLossPerKm += loss;
                //     }
                //     GpsTracker.lastAltitude = altitude;
                // });
            }

            this.checkForWin();
        } catch (err) {
            console.log('ERROR: ' + JSON.stringify(err));
        }
    }

    searchForCity(lat, lng) {
        this.trackingService.searchByCityName(lat, lng).then((res: any) => {
            if (res.length != 0) {
                this.city = res.address.city || res.name;
                this.country_code = res.address.country_code;
            }
        })
    }

    pointsBuffer = [];
    getSymetry(curr, back) {
        let lat = (curr.coords.latitude - back.lat());
        let lng = (curr.coords.longitude - back.lng());
        let newCoord = {
            latitude: null,
            longitude: null
        };

        if (lat <= 0 && lng >= 0) {
            // newCoord.latitude = curr.coords.latitude - Math.abs(lat);
            newCoord.longitude = curr.coords.longitude + lng;
        }
        else if (lat <= 0 && lng <= 0) {
            // newCoord.latitude = curr.coords.latitude - Math.abs(lat);
            // newCoord.longitude = curr.coords.longitude - Math.abs(lng);
        }
        else if (lat >= 0 && lng <= 0) {
            // newCoord.latitude = curr.coords.latitude + lat;
            //newCoord.longitude = curr.coords.longitude - Math.abs(lng);
        }
        else if (lat >= 0 && lng >= 0) {
            newCoord.latitude = curr.coords.latitude + lat;
            newCoord.longitude = curr.coords.longitude + lng;
        }

        return newCoord;
    }

    checkForWin() {
        if (!this.paused) this.setCurrentTime();

        if (!this.DISTANCE_TO_WIN) return;

        if (!this.hasRoute) {
            if (GpsTracker.sumDistance >= this.DISTANCE_TO_WIN) {
                GpsTracker.sumDistance = this.DISTANCE_TO_WIN;
                if (!this.raceFinished) {
                    //this.reachedSub.next(true);
                    this.raceFinished = true;
                }
                return;
            }
        }

        if (this.hasRoute) {
            let tolerance = 2;
            let correctedDistance = this.DISTANCE_TO_WIN - ((this.DISTANCE_TO_WIN * tolerance) / 100);
            if ((GpsTracker.sumDistance >= correctedDistance) && this.atFinishPoint) {
                // GpsTracker.sumDistance = this.DISTANCE_TO_WIN;
                if (!this.raceFinished) {
                    // this.reachedSub.next(true);
                    this.raceFinished = true;
                }
                return;
            }
        }

        this.sendOneKmSignal();
    }

    getNearestCompetitors(loc) {

        let resultArray = [];
        let coordsArray = this.getMapPath();
        let n = coordsArray.length;

        if (n <= 3) {
            return resultArray;
        };

        let positionBehind = coordsArray[coordsArray.length - 4];

        if (this.competitors.length != 0 && this.getCurrentDuration() != 0) {
            let array = LocationHandlerUtil.findNearestCompetitors(this.competitors.slice(), { distance: GpsTracker.sumDistance, time: this.getCurrentDuration() });

            for (let i = 0; i < array.length; i++) {
                let location = loc;

                let coord;
                if (array.length == 1 && array[0].position === "right" || array.length == 1 && array[0].position === "left" || array.length == 2) {
                    coord = this.getSymetry(location, positionBehind);
                }

                let image = (array[i].picName.length == 0) ? "assets/imgs/person-around-blue.png" : array[i].picName;
                ///assets/imgs/default-image-32@1x.png

                if (array[i].position === "left") {
                    let userData = {
                        name: array[i].athleteName,
                        athleteId: array[i].athleteId,
                        image: image,
                        coords: positionBehind,
                        position: array[i].position,
                        time: array[i].cid,
                        place: array[i].place
                    }
                    //resultArray.push(userData);
                }

                else if (array[i].position === "right") {
                    let userData = {
                        name: array[i].athleteName,
                        athleteId: array[i].athleteId,
                        image: image,
                        coords: coord,
                        position: array[i].position,
                        time: array[i].cid,
                        place: array[i].place
                    }
                    //resultArray.push(userData);
                }

            }
        }
        return resultArray;
    }

    sendOneKmSignal() {
        let distance = this.trackingService.options.distanceUnit == DistanceUnit.KM ? (GpsTracker.sumDistance / this.KM_PACE) : (GpsTracker.sumDistance / this.KM_PACE) * 0.621371;
        let currentKM = Math.floor(distance);
        if (!this.checkPoints[currentKM] && currentKM >= 1) {
            if (!this.raceFinished) {
                this.checkPoints[currentKM] = true;
                //this.reachedSub.next(false);
                setTimeout(() => {
                    GpsTracker.altitudeGainPerKm = 0;
                    GpsTracker.altitudeLossPerKm = 0;
                }, 700);
            }
            return;
        }
    }

    calcSpeed() {
        if (this.trackingService.options.distanceUnit == DistanceUnit.KM) {
            return LocationHandlerUtil.calcPace(GpsTracker.sumDistance, this.getCurrentDuration());
        } else {
            return LocationHandlerUtil.calcPaceMilie(GpsTracker.sumDistance, this.getCurrentDuration());
        }
    }

    setCurrentTime() {
        if (!this.paused) {
            let now = new Date();
            let diff = Math.round((now.getTime() - this.startTime.getTime()) / 1000);
            this.config.currentDuration = diff;
        }
    }

    setSubscriptions(reachedSub, reachedStartingPointSub) {
        this.reachedSub = reachedSub;
        this.reachedStartingPointSub = reachedStartingPointSub;
    }

    setPlacement(value) {
        this.placement = value;
    }

    removePlacement() {
        this.getMapHandler().deleteMarkers();
        this.placement = false;
    }

    getMaxSpeed() {
        return GpsTracker.maxSpeed;
    }

    getAvgSpeed() {
        return GpsTracker.avgSpeed;
    }

    getCurrentSpeed() {
        return GpsTracker.currentSpeed;
    }

    getSumDistance() {
        return GpsTracker.sumDistance;
    }

    getMapPath() {
        return this.getMapHandler().getPolyDestinations();
    }

    setMapPath(o) {
        this.getMapHandler().setPolyDestinations(o);
        this.getMapHandler().setPolyDraw();
    }

    getConfig() {
        return this.config;
    }

    setConfigure(options) {
    }

    draw() {
        // this.afterCalculate();
        this.getMapHandler().drawPolyLines(true);
        //this.getMapHandler().positionMarker(this.config.prev.data);
    }

    setIsError(v) {
        this.config.isError = v;
    }

    setErrorCnt(e) {
        this.config.errorCnt = e;
    }

    getIsCalculate() {
        return this.config.isCalculate;
    }

    setIsCalculate(v) {
        this.config.isCalculate = v;
    }

    getCurrentDuration() {
        return this.config.currentDuration;
    }

    setCurrentDuration(o: number) {
        this.config.currentDuration = o;
    }

    setBetterPos(geo) {
        this.config.betterPos = geo;
    }

    getBetterPos() {
        return this.config.betterPos;
    }

    setPrev(obj) {
        this.config.prev = obj;
    }

    getPrev() {
        return this.config.prev;
    }

    getLastPos() {
        return this.config.lastPos;
    }

    setLastPos(pos) {
        this.config.lastPos = pos;
    }

    setMap(map) {
        this.getMapHandler().setMap(map);
        this.onFirstPositionFind();
    }

    setMapCenter(zoom) {
        this.getMapHandler().setMapCenterZoom(zoom);
    }

    getMap() {
        // @ts-ignore
        return this.config.mapHandler.getMap();
    }

    getSplited() {
        return this.config.splited;
    }

    setSplited(s) {
        this.config.splited = s;
    }

    setLastStep(time) {
        this.config.lastStep = time - this.startTime.getTime();
    }

    getLastStep() {
        return this.config.lastStep;
    }

    // getStartPosition() {
    //     return this.config.startPosition;
    // }

    getMapHandler(): MapHandlerCreator {
        return this.config.mapHandler;
    }

    getTrackSession() {
        return this.trackSession;
    }

    setStarted(s) {
        this.config.started = s;
    }

    getStarted() {
        return this.config.started;
    }


    refreshMarker() {
        this.getMapHandler().clearMeMarker();
        this.getMapHandler().positionMarker(this.lastCoordinates);
    }

    /**
    * @event activitychange
    */
    onActivityChange(event: any) {
        this.motionActivity = `${event.activity}:${event.confidence}%`;
    }

    /**
    * @event http
    */
    onHttpSuccess(response: any) {
    }
    onHttpFailure(response: any) {
    }

    /**
    * @event heartbeat
    */
    onHeartbeat(event: any) {
        let location = event.location;
        // NOTE:  this is merely the last *known* location.  It is not the *current* location.  If you want the current location,
        // fetch it yourself with #getCurrentPosition here.
    }

    /**
    * @event powersavechange
    */
    onPowerSaveChange(isPowerSaveEnabled) {
        // this.toast('[event] powersavechnage, Power-save mode enabled? ', isPowerSaveEnabled);
    }
    onConnectivityChange(event: any) {
        // this.toast('[event] connectivitychange: Network connected? ', event.connected);
    }
    /**
    * @event providerchange
    */
    onProviderChange(provider: any) {
        this.provider = provider;
    }

    /**
    * @event motionchange
    */
    onMotionChange(event: any) {
        this.zone.run(() => {
            this.isMoving = event.isMoving;
        });
    }

    locationCounts: number = 0;
    localDistance: number = 0;
    /**
     * @event location
    */
    onLocation(location: Location) {

        this.geoSuccess(location);

        // if ((location.odometer + this.odometer) - GpsTracker.sumDistance > 300) {
        //     this.odometer = GpsTracker.sumDistance;
        //     BackgroundGeolocation.resetOdometer(() => console.log('- BG reset success'));
        //     return;
        // }

        // if (this.lastCoordinates && this.paused) {
        //     this.autoStartTrigger = !LocationHandlerUtil.defDistance(location.coords, this.lastCoordinates.coords, 1500);
        // } else if (!this.paused && this.stopWatch) {
        //     this.autoStartTrigger = false;
        // }

        this.zone.run(() => {

            if (!this.paused && this.stopWatch) {
                AutoPause.getInstance().setLastAction(new Date());

                if (!this.isMoving) {
                    BackgroundGeolocation.changePace(true, () => { });
                }
                if (this.locationCounts++ < 9) {
                    // this.localDistance = location.odometer;
                } else {
                    if (this.localDistance > 1000) {
                        //  GpsTracker.sumDistance = location.odometer + this.odometer - this.localDistance;
                    } else {
                        //  GpsTracker.sumDistance = location.odometer + this.odometer;
                    }
                }

                this.lastCoordinates = location;
                localStorage.setItem('lastPos', JSON.stringify(location));
            }
        });
    }

    async configureBackgroundGeolocation() {
        let token = localStorage.getItem("token");
        let eventId = localStorage.getItem("eventId") || "-1";
        let accuracyStr = localStorage.getItem("accuracy");
        let accuracy;
        if (accuracyStr) {
            accuracy = new Number(accuracyStr);
        }
        ////
        // Step 1:  listen to events
        //
        BackgroundGeolocation.onLocation(this.onLocation.bind(this));
        BackgroundGeolocation.onMotionChange(this.onMotionChange.bind(this));
        BackgroundGeolocation.onActivityChange(this.onActivityChange.bind(this));
        BackgroundGeolocation.onHttp(this.onHttpSuccess.bind(this));
        BackgroundGeolocation.onProviderChange(this.onProviderChange.bind(this));
        BackgroundGeolocation.onHeartbeat(this.onHeartbeat.bind(this));
        BackgroundGeolocation.onPowerSaveChange(this.onPowerSaveChange.bind(this));
        BackgroundGeolocation.onConnectivityChange(this.onConnectivityChange.bind(this));
        ////
        // Step 2:  Initialize the plugin
        //
        BackgroundGeolocation.ready({
            autoSync: false,
            // Logging / Debug config
            url: `${environment.routeApi}user/location/save`,
            // url: "http://localhost:8080/savelocation",
            headers: {
                "content-type": "application/json"
            },
            locationTemplate: '{"latitude":<%= latitude %>,"longitude":<%= longitude %>}',
            extras: {
                "token": token
                // "eventId": eventId
            },
            debug: false,
            logLevel: BackgroundGeolocation.LOG_LEVEL_ERROR,
            desiredAccuracy: accuracy || BackgroundGeolocation.DESIRED_ACCURACY_MEDIUM,  // <-- highest possible accuracy
            distanceFilter: 5,
            stopTimeout: 1,
            reset: true,
            stopOnTerminate: false,
            stopOnStationary: false,
            startOnBoot: this.startOnBoot,
            heartbeatInterval: 60,
            disableElasticity: true,
            // [Android] backgroundPermissionRationale for Always permission.
            backgroundPermissionRationale: {
                title: "Ermöglichen Sie {applicationName}, auf den Speicherort dieses Geräts zuzugreifen, auch wenn es geschlossen ist oder nicht verwendet wird.",
                message: "Diese App verarbeitet Standortdaten, um das GPS Tracking zu ermöglichen.",
                positiveAction: 'Wechseln Sie zu "{backgroundPermissionOptionLabel}"',
                negativeAction: 'Abbrechen'
            },
            // HTTP / Persistence config
            notification: {
                smallIcon: "drawable/ic_notification"
            }
        }, () => {
            this.zone.run(() => {
                BackgroundGeolocation.start(() => {
                    BackgroundGeolocation.changePace(true, () => { }, (err) => {
                        console.log('ERROR: ' + err);
                    });
                });
            });
        }, (err) => {
            console.error(err);
        });
    }

    /**
  * Send a Toast message
  */
    private async toast(message, duration?) {
        (await this.toastCtrl.create({
            message: message,
            duration: duration || 3000,
            position: 'top'
        })).present();
    }
}